import ModalDialog from '@ui/modal/ModalDialog';
import analytics from '@utils/analytics';
import api from '@utils/api';
import useQueryStringBoolean from '@utils/useQueryStringBoolean';
import classNames from 'classnames';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
const LanguageModal = (props) => {
    const { t } = useTranslation();
    const [open, setOpen] = useQueryStringBoolean('localeselector');
    const [data, setData] = useState();
    useEffect(() => {
        if (open) {
            api.languageSelectorJson().then((data) => {
                setData(data);
            });
        }
    }, [open]);
    const modal = () => (React.createElement(ModalDialog, { isOpen: open, onRequestClose: () => {
            setOpen(false);
            analytics.languageselectorClose();
        }, hasDivisor: true, contentLabel: t('modal.language.title'), subtitle: t('modal.language.description') },
        React.createElement(React.Fragment, null,
            React.createElement("div", { className: "language-wrapper mt-32" },
                React.createElement("div", { className: "continent-title" },
                    React.createElement("ul", null, data.map((lang) => {
                        var _a;
                        return (React.createElement("li", { key: lang.link },
                            React.createElement("a", { href: ((_a = document.querySelector(`link[rel="alternate"][hreflang="${lang.language}-${window.country}"]`)) === null || _a === void 0 ? void 0 : _a.href) || lang.link, onClick: () => {
                                    analytics.languageselectorClick(lang.name.toLowerCase());
                                } }, lang.name)));
                    })))))));
    return (React.createElement(React.Fragment, null,
        React.createElement("button", { type: "button", className: classNames('footer-menu__menuitem', { container: props.contained }), "aria-haspopup": "dialog", onClick: () => setOpen(true) },
            React.createElement("span", { className: "footer-menu__menuitem__item" }, t('footer.item.language')),
            React.createElement("span", { className: "footer-menu__menuitem__current" }, props.current)),
        data && modal()));
};
export default LanguageModal;
